import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { TranslationsSiteConfig } from '../types'

export const translationsSiteConfig: SiteConfigFn<TranslationsSiteConfig> = () => {
	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

export const name = 'translations'
